import {
  getDocs,
  getDoc,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  //   query,
  //   orderBy,
  //   limit,
  //   onSnapshot,
  //   setDoc,
  //   serverTimestamp,
  serverTimestamp,
} from 'firebase/firestore';
import { db, bookCollection } from './firebase.config';

const FireBase = {
  getAllBooks: async () => {
    try {
      return await getDocs(bookCollection);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  getBook: async (id) => {
    try {
      const bookDoc = doc(db, 'books', id);
      return await getDoc(bookDoc);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  newBook: async (addBook) => {
    try {
      return await addDoc(bookCollection, { ...addBook, createdAt: serverTimestamp() });
    } catch (error) {
      throw new Error(error.message);
    }
  },

  updateBook: async (id, updatebook) => {
    try {
      const bookDoc = doc(db, 'books', id);
      return await updateDoc(bookDoc, updatebook);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  deleteBook: async (id) => {
    try {
      const bookDoc = doc(db, 'books', id);
      return await deleteDoc(bookDoc);
    } catch (error) {
      throw new Error(error.message);
    }
  },
};

export default FireBase;
